import type { ListingDetailV3Data } from '@/src/lib/api/endpoints/listing';
import type { HpApiListingsV3Handler_priceHistory } from '@zg-rentals/ts-hotpads-api-client';

/** `meta.context.details` of the price history query, so expected failures can be recognised. */
export const PRICE_HISTORY_QUERY_DETAILS = 'rental price history';

export type PriceHistoryIdentity = Parameters<typeof HpApiListingsV3Handler_priceHistory>[0];

export function resolvePriceHistoryIdentity(
  detail: ListingDetailV3Data,
  selectedUnit?: string | null,
): PriceHistoryIdentity | undefined {
  const listingAlias = detail.resolved?.listingAlias;
  if (!listingAlias) return undefined;

  const floorplans = detail.floorplans ?? [];
  const units = floorplans.flatMap((floorplan) => floorplan.units ?? []);
  const unit = detail.resolved?.unit?.trim() || selectedUnit?.trim();
  const candidates = unit
    ? units.filter((candidate) => candidate.name === unit || candidate.modelId === unit)
    : [...floorplans, ...units];
  if (candidates.some((candidate) => !candidate.modelId)) return undefined;
  const modelIds = new Set(candidates.map((candidate) => candidate.modelId).filter(Boolean));

  // A floorplan can repeat its only unit's model ID; multiple distinct models need an exact selection.
  if (modelIds.size !== 1) return undefined;
  const modelId = [...modelIds][0];
  return modelId ? { listingAlias, modelId } : undefined;
}
